import * as z from "zod/v4";

export const rerunAutomations = {
  name: "rerunAutomations" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()).nullish() }),
  output: z.object({ success: z.boolean(), error: z.string().nullish() }),
};
